import SVGIconWrapper from "./SVGIconWrapper"

const IconDownload = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 572 509"
        iconClass={`icon--download ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M280 1c41.6-.5 36 34.7 36 75v186l84-83c17.9-10.5 38.2 3.2 43 16 8.6 22.8-13.6 37.6-23 47l-98 97c-9.5 9.5-23 30.3-45 23-16.9-5.6-30.2-26.2-42-38l-92-91c-10.6-10.6-22.2-29.5-9-47 7.5-9.9 29-13.7 41-5l81 81V92c0-22.7-4.8-57.6 3-75 4-8.9 12.6-11.3 21-16zM25 307c45.7 2.5 22.9 46.7 33 84 8.7 32.1 33.2 54.9 68 61h250c45 0 85.3 2.2 110-17 13.6-10.6 24.9-29.2 29-49 6.7-32-9.1-69.5 21-78 39.7-11.2 41.1 46.4 35 81-25 141.4-153.7 119-315 119-88.1 0-158.5 7.2-208-32-31.9-25.2-48-64.4-48-122 0-13.6-.7-27.1 5-35s12.1-8.1 20-12z" />
    </SVGIconWrapper>
)

export default IconDownload